module.exports = __webpack_public_path__ + "img/about-us-img.4a0820ac.png";